import axios from 'axios';
import { useCallback } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { createAxiosConfigWithAuth } from '../../../common/apiHelpers';
import config from '../../../common/config';
import {
  HOME_NOBLE_COACH_INVITATION_BEGIN,
  HOME_NOBLE_COACH_INVITATION_DISMISS_ERROR,
  HOME_NOBLE_COACH_INVITATION_FAILURE,
  HOME_NOBLE_COACH_INVITATION_SUCCESS,
} from './constants';

export function nobleCoachInvitation(args = {}) {
  return (dispatch, getState) => {
    // optionally you can have getState as the second argument
    dispatch({
      type: HOME_NOBLE_COACH_INVITATION_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${config.apiRootUrl}/users/create-noble-coach/`,
        args,
        createAxiosConfigWithAuth(getState()),
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_NOBLE_COACH_INVITATION_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: HOME_NOBLE_COACH_INVITATION_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissNobleCoachInvitationError() {
  return {
    type: HOME_NOBLE_COACH_INVITATION_DISMISS_ERROR,
  };
}

export function useNobleCoachInvitation() {
  const dispatch = useDispatch();

  const { nobleCoachInvitationPending, nobleCoachInvitationError } =
    useSelector(
      (state) => ({
        nobleCoachInvitationPending: state.home.nobleCoachInvitationPending,
        nobleCoachInvitationError: state.home.nobleCoachInvitationError,
      }),
      shallowEqual,
    );

  const boundAction = useCallback(
    (...args) => {
      return dispatch(nobleCoachInvitation(...args));
    },
    [dispatch],
  );

  const boundDismissError = useCallback(() => {
    return dispatch(dismissNobleCoachInvitationError());
  }, [dispatch]);

  return {
    nobleCoachInvitation: boundAction,
    nobleCoachInvitationPending,
    nobleCoachInvitationError,
    dismissNobleCoachInvitationError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_NOBLE_COACH_INVITATION_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        nobleCoachInvitationPending: true,
        nobleCoachInvitationError: null,
      };

    case HOME_NOBLE_COACH_INVITATION_SUCCESS:
      // The request is success
      return {
        ...state,
        nobleCoachInvitationPending: false,
        nobleCoachInvitationError: null,
      };

    case HOME_NOBLE_COACH_INVITATION_FAILURE:
      // The request is failed
      return {
        ...state,
        nobleCoachInvitationPending: false,
        nobleCoachInvitationError: action.data.error,
      };

    case HOME_NOBLE_COACH_INVITATION_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        nobleCoachInvitationError: null,
      };

    default:
      return state;
  }
}
